import { Component } from "../components/index"
import gsap from "gsap"
import { qsa, qs } from "../utils/index"
import Slider from "../components/Slider"
import store from "../store"

export default class HeroCollection extends Component {
  constructor(obj) {
    super(obj)

    this.sliderDOM = qs(".slider", this.el)
    this.slider = new Slider(this.sliderDOM)
  }
}
